import { CheckboxLabel } from '@/components/Atoms/CheckboxLabel/CheckboxLabel';
import { FindIcon } from '@/components/Icons/FindIcon';
import { DetailsDropdown } from '@/components/Molecules/DetailsDropdown/DetailsDropdown';
import type { IFormChoice } from '@/interfaces';
import type { HTMLAttributes } from 'react';
import type { FCl } from 'react-fc';
import styles from './SingleDropdown.module.css';

interface ISingleSelectionProps {
    title: string;
    name: string;
    onChange: (x: IFormChoice) => void;
    options: (IFormChoice & { onChange?: (x: IFormChoice) => void })[];
    selectedValue?: string;
}

export const SingleDropdown: FCl<ISingleSelectionProps> = ({ title, className, ...rest }) => {
    return (
        <DetailsDropdown dynamicLabel label={title} className={className} closeOnClick>
            <div className={styles.optionsContainer}>
                <SingleDropdownList {...rest} />
            </div>
        </DetailsDropdown>
    );
};

export const SingleDropdownList: FCl<
    Omit<ISingleSelectionProps, 'title'> & Omit<HTMLAttributes<HTMLUListElement>, 'onChange'>
> = ({ name, options, onChange, selectedValue, ...rest }) => (
    <ul className={styles.optionsList} {...rest}>
        {options.map((x, i) => (
            <li key={x.value || `i-${i}`}>
                <CheckboxLabel className={styles.label}>
                    <input
                        name={name}
                        value={x.value}
                        type="radio"
                        checked={selectedValue === x.value}
                        onChange={() => (x.onChange ? x.onChange(x) : onChange(x))}
                    />
                    {x.iconName && <FindIcon iconName={x.iconName} />}
                    <span>{x.label}</span>
                </CheckboxLabel>
            </li>
        ))}
    </ul>
);
